/* eslint-disable prefer-arrow-callback */
import { Breakpoints } from '../breakpoints/breakpoints';
import { DragBar } from '../drag-bar/drag-bar';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.timeline',
        content: '.timeline__content',
        yearline: '.timeline__yearline',
        items: '.timeline__items',
        item: '.timeline__item',
        itemYearIndicator: '.timeline__yearline',
        yearControl: '.timeline__year-control',
        timelineInner: '.timeline__inner',
        fixedYearCentury: '.timeline__fixed-year-century-inner',
        fixedYearDecade: '.timeline__fixed-year-decade-inner',
        fixedYearDecadeText: '.timeline__fixed-year-decade-inner',
        intro: '.timeline__intro',
        controlBtn: '.drag-bar__control-btn',
    },
    dataAttributes: {
        items: 'items',
        year: 'year',
    },
    classNames: {
        translated: 'timeline__content--translated',
        prevItem: 'timeline__item--prev',
        fixedYearDecadeHidden: 'timeline__fixed-year-decade-inner--hidden',
        fixedYearDecadeShowTransition: 'timeline__fixed-year-decade-inner--show-transition',
        fixedYearCenturyHidden: 'timeline__fixed-year-century-inner--hidden',
        fixedYearCenturyShowTransition: 'timeline__fixed-year-century-inner--show-transition',
        introHidden: 'timeline__intro--hidden',
    },
};

class Timeline {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._items = [];
        this._years = [];
        this._decades = [];
        this._centurys = [];
        this._currentYear = 0;
        this._previousCentury = 0;
        this._lastCentury = 0;
        this._lastDecade = 0;
        this._currentDecade = 0;
        this._currentCentury = 0;
        this._currentIndex = 0;
        this._activeIndex = 0;
        this._translate = 0;
        this._itemWidth = 0;
        this._itemMarginRight = 0;
        this._yearLineItemLineLeft = 0;
        this._centuryWidth = 0;
        this._previousGoTo = 0;
        this._isLeft = true;
        this._decadeWidth = 0;
        this._lastClickCentury = 0;
        this._animationLength = 750;
        this._lineOffset = 20;
        this._yearEndMarker = '';
        
        // mobile variables
        this._touchStart = 0;
        this._delta = 0;
        this._isBeingTouched = false;
    }

    init() {
        const smartedit = $('body').data('smartedit');

        if(smartedit === true || smartedit === 'true') {
            return;
        }
        
        this._yearEndMarker = this._$rootElement.data('year-end-marker');
        this._elements = this._getDomElements();
        // this._elements.$items.slick(config.sliderConfig);
        this._extractYearsAndDecades();


        // create draggable div
        this._calcItemWidth();

        const itemHTML = this._elements.$items[0].innerHTML;

        let draggable = `
            <div class="timeline__draggable">
                ${itemHTML}
            </div>
        `;

        this._elements.$items.html(draggable);
        
        this._activeIndex = 0;
        this._elements.$items.find(config.selectors.item).find('img').attr('draggable', false);
        this._calcItemMarginRight();
        this._generateYearline();
        this._addEventListeners();
        this._initBar();
        this._setItemsHeight();
        this._elements.$fixedYearCentury.html(this._centurys[0]);
        this._centuryWidth = this._elements.$fixedYearCentury.width();
        this._elements.$fixedYearDecade.html(this._decades[0]);
        this._decadeWidth = this._$rootElement.find('.timeline__fixed-year-decade').width();
        this._currentCentury = this._centurys[0];
        this._currentDecade = this._decades[0];
        this._setYearlineItemLeft();
    }

    _getDomElements() {
        return {
            $content: this._$rootElement.find(config.selectors.content),
            $yearline: this._$rootElement.find(config.selectors.yearline),
            $items: this._$rootElement.find(config.selectors.items),
            $item: this._$rootElement.find(config.selectors.item),
            $yearControl: this._$rootElement.find(config.selectors.yearControl),
            $timelineInner: this._$rootElement.find(config.selectors.timelineInner),
            $fixedYearCentury: this._$rootElement.find(config.selectors.fixedYearCentury),
            $fixedYearDecade: this._$rootElement.find(config.selectors.fixedYearDecade),
            $fixedYearDecadeText: this._$rootElement.find(config.selectors.fixedYearDecadeText),
            $intro: this._$rootElement.find(config.selectors.intro),
        };
    }

    _addEventListeners() {
        const _this = this;

        // x value to calculate scroll distance since mousedown
        let lastPageX = 0;

        // and additional translate value with which we start to calculate
        let startTranslate = 0;

        // mobile device handler
        this._$rootElement.find('.timeline__draggable').on('touchstart', () => this._onTouchStart());
        this._$rootElement.find('.timeline__draggable').on('touchmove', (e) => this._onTouchMove(e));

        // desktop drag handler
        this._$rootElement.find('.timeline__draggable').on('mousedown', function(e){

            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                return;
            }

            if(_this._isTouchDevice() || _this._isBeingTouched) return;
            // console.log('mousedown');
            lastPageX = 0;
            startTranslate = _this._translate;
            // console.log('startTranslate: ', startTranslate);

            _this._$rootElement.find('.timeline__fixed-year-century').css('opacity', `1`);
            _this._$rootElement.find('.timeline__year-line-item-decade').css('transition', `none`);

            // cancel when mouseup
            $(this).one('mouseup', function(e) {
                // console.log('mouseup');
                $(this).off('mousemove');

                _this._goToFromClick();
            });

            let previousDifference = 0;
            let isLeft = false;

            $(this).on('mousemove', function(e){
                if(lastPageX === 0) {
                    lastPageX = e.pageX;
                }

                const difference = lastPageX - e.pageX;
                isLeft = difference - previousDifference > 0;
                const translateX = -difference - startTranslate > 0 ? 0 : -difference - startTranslate;
                _this._translate = translateX;

                // console.log('scroll distance', _this._getPositiveScrollDistanceFromContent());

                // if(_this._getPositiveScrollDistanceFromContent() > 30) {
                //     const currentItem = _this._$rootElement.find(`.timeline__year-line-item[data-index="${_this._activeIndex}"]`);
                //     if(currentItem.hasClass('timeline__year-line-item--no-century')) {
                //        currentItem.find('.timeline__year-line-item-century').css('width', 0);
                //     }
                // }

                if(_this._translate !== 0 && _this._translate > (Math.ceil(_this._decadeWidth) + this._lineOffset)) {
                    // console.log('line hits century');
                }

                _this._updateActiveIndexByPosition();
                _this._updateIntroOpacity();
                _this._updateDecadeOpacity();
                _this._updateDragbar();
                _this._updateTranslations();
                _this._updateFixedYearState();

                previousDifference = difference;
            });   
        });

        $('body').on('click', function(e) {
            _this._$rootElement.find('.timeline__draggable').off('mousemove');
        });

        $(window).on('resize', () => {
            if(this._isTouchDevice() || this._isBeingTouched) return;

            this._setControlBtnWidth();
            this._setItemsHeight();
            this._calcItemWidth();
            this._calcItemMarginRight();
            this._updateIntroOpacity();
            this._updateTranslations();
            this._goTo();
        });
    }

    _onTouchMove(e) {
        if(!this._isBeingTouched) return;

        const position = (e.changedTouches[0].clientX - window.innerWidth / 2) * 0.5;

        if(this._touchStart === 0) {
            this._touchStart = position
        }

        this._delta = position;  
    }

    _onTouchStart() {
        if(!this._isBeingTouched) {
            this._$rootElement.find('.timeline__draggable').one("touchend", () => this._onTouchEnd());
        }
        
        this._isBeingTouched = true;
    }

    _onTouchEnd() {
        if(!this._isBeingTouched) return;
        
        if(this._delta - this._touchStart > 0) {
            if(this._activeIndex > 0) {
                this._activeIndex = this._activeIndex - 1;
                this._goToFromClick(true);
            }
        } else {
            if(this._activeIndex < this._elements.$item.length - 1) {
                this._activeIndex = this._activeIndex + 1;
                this._goToFromClick(true);
            }
        }

        this._touchStart = 0;

        setTimeout(() => {
            this._isBeingTouched = false;    
        }, this._animationLength)
        
    }

    _calcItemWidth() {
        const itemWidth = $(this._elements.$items[0]).width();
        this._elements.$items.find(config.selectors.item).width(itemWidth);
        this._itemWidth = itemWidth;
    }

    _calcItemMarginRight() {
        const itemMarginString = this._elements.$items.find(config.selectors.item).css('marginRight');
        this._itemMarginRight = Number(itemMarginString.substring(0, itemMarginString.length - 2));
    }

    _setYearlineItemLeft() {
        this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
            const $el = $(el);
            const centuryWidth = $el.find('.timeline__year-line-item-century').width() || 0;
            const decadeWidth = $el.find('.timeline__year-line-item-decade').width() || 0;
            const combinedWidth = centuryWidth + decadeWidth;
            const width = combinedWidth  === 0 ? this._itemMarginRight + this._itemWidth + this._lineOffset : this._itemMarginRight + this._itemWidth - combinedWidth - this._lineOffset;
            const left = combinedWidth  === 0 ? combinedWidth : combinedWidth + 10;
            this._yearLineItemLineLeft = left;
            this._yearLineItemLineWidth = width;
            $el.find('.timeline__year-line-item-line').css('width', width);
            $el.lineWidth = width;
            $el.find('.timeline__year-line-item-line').css('right', combinedWidth === 0 ? 0 : this._lineOffset);
        });
    }

    _updateActiveIndexByPosition() {
        const oldIndex = this._activeIndex;
        this._activeIndex = this._getActiveIndexByPosition();

        if(oldIndex !== this._activeIndex) {
            // console.log('index changed while dragging');
        }
    }

    _getActiveIndexByPosition() {
        return Math.ceil(this._translate / Math.ceil(this._itemWidth + this._itemMarginRight)) * -1;
    }

    _updateIntroOpacity() {
        let introOpacityFactor = this._translate / (this._itemMarginRight + this._itemWidth) * -1;
        introOpacityFactor = 1 - (introOpacityFactor > 1 ? 1 : introOpacityFactor);
        this._elements.$intro.css('opacity', introOpacityFactor);
    }

    _updateDecadeOpacity() {
        const activeIndex = this._getActiveIndexByPosition();
        const currentItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${activeIndex}"]`);

        if(activeIndex === 0) {
            let decadeOpacityFactor = 1 - ((this._translate % ((this._itemWidth + this._itemMarginRight))) / (-100))
            currentItem.find('.timeline__year-line-item-decade').css('opacity', decadeOpacityFactor);
            currentItem.find('.timeline__year-line-item-line').css('opacity', decadeOpacityFactor);                
        } else {
            let decadeOpacityFactor = 1 - ((this._translate % ((this._itemWidth + this._itemMarginRight) * activeIndex)) / (-100 * activeIndex))
            currentItem.find('.timeline__year-line-item-decade').css('opacity', decadeOpacityFactor);              
            currentItem.find('.timeline__year-line-item-line').css('opacity', decadeOpacityFactor);                  
        }
    }   

    _updateDragbar() {
        const $bar = this._elements.$yearControl.find(DragBar.getClassname());
        DragBar.setIndex($bar, this._activeIndex); 
    }

    _getScrollDistanceFromContent() {
        const factor = (this._itemWidth + this._itemMarginRight) * this._activeIndex;
        if(factor === 0) {
            return this._translate;
        } else {
            return this._translate % ((this._itemWidth + this._itemMarginRight) * this._activeIndex);
        }
    }

    _getPositiveScrollDistanceFromContent() {
        return this._getScrollDistanceFromContent() * -1;
    }

    _updateTranslations() {
        const activeIndex = this._getActiveIndexByPosition();
        const prevItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${activeIndex - 1}"]`);
        const currentItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${activeIndex}"]`);
        const nextItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${activeIndex + 1}"]`);

        let additionalTranslate = this._$rootElement.find('.timeline__fixed-year-century').width() + this._elements.$intro.width() - this._itemWidth;
        additionalTranslate = additionalTranslate * (this._translate % (this._itemWidth + this._itemMarginRight) / (this._itemWidth + this._itemMarginRight));

        // apply transformations
        this._$rootElement.find('.timeline__year-line-root').css('transform', `translateX(${this._translate}px)`);  
        this._$rootElement.find('.timeline__draggable').css('transform', `translateX(${this._translate}px)`); 

        if(additionalTranslate < -5) {
            nextItem.find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate * -1}px)`);                
            nextItem.find('.timeline__year-line-item-century').css('transform', `translateX(${additionalTranslate * -1}px)`);  
        }
        

        if(nextItem.hasClass('timeline__year-line-item--no-decade')) {
            currentItem.find('.timeline__year-line-item-line').css('right', `${additionalTranslate}px`);
        } else {
            currentItem.find('.timeline__year-line-item-line').css('right', `${additionalTranslate + this._lineOffset}px`);
        }
        
        currentItem.find('.timeline__year-line-item-line').css('width', `${this._yearLineItemLineWidth + (additionalTranslate) - this._lineOffset}px`);                

        prevItem.find('.timeline__year-line-item-line').css('right', this._lineOffset);
        prevItem.find('.timeline__year-line-item-line').css('width', `${this._yearLineItemLineWidth - this._lineOffset * (this._activeIndex - 1)}px`);                
    }

    _updateFixedYearState() {
        const nextItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex + 1}"]`);
        const currentItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex}"]`);

        this._currentCentury = currentItem.data('century');
        this._currentDecade = currentItem.data('decade');

        this._$rootElement.find('.timeline__fixed-year-century').html(this._currentCentury);
        this._$rootElement.find('.timeline__fixed-year-decade').html(this._currentDecade);
        
        if(nextItem.hasClass('timeline__year-line-item--no-decade')) {
            this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
        } else {
            this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
        }

        if(!nextItem.hasClass('timeline__year-line-item--no-century')) {
            this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
        } else {
            
        }

        if(!nextItem.hasClass('timeline__year-line-item--no-decade') && !nextItem.hasClass('timeline__year-line-item--no-century')) {
            this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
            this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 0);
            // currentItem.find('.timeline__year-line-item-century').css('width', 'auto');
            currentItem.find('.timeline__year-line-item-decade').css('transform', 'none');
        }
    }

    _goToNew() {
        // console.log('_goToNew', this._activeIndex);
        const index = this._getActiveIndexByPosition();
        const currentItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${index}"]`);
        const marginFactor = this._itemMarginRight;
        const totalMargin = marginFactor * this._activeIndex;
        const totalItems = this._itemWidth * this._activeIndex;
        const total = totalItems + totalMargin + this._elements.$intro.width() - this._itemWidth;
        

        const difference = this._activeIndex === 0 ? -this._translate : -this._translate - total;
        const step = difference / 1000;

        this._updateDragbar();
        this._currentCentury = currentItem.data('century');
        this._currentDecade = currentItem.data('decade');

        let i = 0;
        for(let i = 0; i < 100; i++) {
            setTimeout(() => {
                this._translate += step;
                this._updateIntroOpacity();
                this._updateDecadeOpacity();                
                this._updateTranslations();
                this._updateFixedYearState();

                if(i === 99) {
                    this._$rootElement.find('.timeline__fixed-year-century').html(this._currentCentury);
                    this._$rootElement.find('.timeline__fixed-year-decade').html(this._currentDecade);
                }
            }, i)
        }

    }

    _goToFromClick(registerTouchEnd = false) {
        // isLeft means new index is higher
        const isLeft = this._activeIndex > this._previousGoTo;
        this._updateDragbar();

        const itemWidth = this._itemWidth;
        const draggable = this._$rootElement.find('.timeline__draggable');
        const yearlineRoot = this._$rootElement.find('.timeline__year-line-root');
        const currentItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex}"]`);
        const prevItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex - 1}"]`);
        const nextItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex + 1}"]`);

        const currentDecade = currentItem.find('.timeline__year-line-item-decade');
        // currentItem.find('.timeline__year-line-item-line').css('left', this._centuryWidth + currentDecade.width());

        this._activateTransitions();

        this._lastDecade = this._currentDecade;
        this._lastCentury = this._currentCentury;
        this._currentCentury = currentItem.data('century');
        this._currentDecade = currentItem.data('decade');

        // handle decade & century opacity & line width
        if(isLeft) {
            if(this._activeIndex === 0) {
                this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
                    if(i === this._activeIndex) {
                        $(el).find('.timeline__year-line-item-line').css('width', this._yearLineItemLineWidth + this._lineOffset); 
                    }
                });
            } else {
                this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
                    if(i < this._activeIndex) {
                        // for all previous items, we let the decade fade out
                        $(el).find('.timeline__year-line-item-decade').css('opacity', 0);

                        // for all previous items, we let the line fade out
                        $(el).find('.timeline__year-line-item-line').css('opacity', 0);

                        // for all previous items, we let the line shrink
                        $(el).find('.timeline__year-line-item-line').css('width', 0);
                    } else if(i === this._activeIndex) {
                        // for the active element, if it has a decade, we need to apply additional translation
                        // for the active element, we need to adjust the line so it fits
                        if(!$(el).hasClass('timeline__year-line-item--no-decade') && !$(el).hasClass('timeline__year-line-item--no-century')) {
                            // if the yearline item which gets active doesnt have a century, but a decade, we need additional translate for its decade
                            let additionalTranslate = 0;
                            
                            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {

                            } else {
                                additionalTranslate += this._elements.$intro.width() - itemWidth;
                            }
                           
                            $(el).find('.timeline__year-line-item-century').css('transform', `translateX(${additionalTranslate}px)`);
                            $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate}px)`);
                            $(el).find('.timeline__year-line-item-line').css('width', this._yearLineItemLineWidth - this._lineOffset);
                        } else if(!$(el).hasClass('timeline__year-line-item--no-decade') && $(el).hasClass('timeline__year-line-item--no-century')) {
                            // if the yearline item which gets active doesnt have a century, but a decade, we need additional translate for its decade
                            let additionalTranslate = this._centuryWidth;
                            
                            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {

                            } else {
                                additionalTranslate += this._elements.$intro.width() - itemWidth;
                            }
                            
                            $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate}px)`);
                            $(el).find('.timeline__year-line-item-line').css('width', this._yearLineItemLineWidth - this._lineOffset);

                        } else {
                            $(el).find('.timeline__year-line-item-line').css('width', $(el).lineWidth);    
                        }

                        $(el).find('.timeline__year-line-item-line').css('opacity', 1);
                    }

                    // since we were going from low to high (isLeft), next items shouldnt need to get touched     
                });
            }
            
            // if the decade changes, we need to hide the fixed decade
            if(this._currentDecade != this._lastDecade) {
                this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
            }

            // if the century changes, we need to hide the fixed century
            if(this._currentCentury != this._lastCentury) {
                this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 0);
            }
        } else {
            if(this._activeIndex === 0) {
                this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
                    // remove translation from all decades
                    $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(0)`);

                    // for all items, we let the decade fade in
                    $(el).find('.timeline__year-line-item-decade').css('opacity', 1);

                    // for all items, we let the line fade in
                    $(el).find('.timeline__year-line-item-line').css('opacity', 1);

                    if(i === this._activeIndex) {
                        $(el).find('.timeline__year-line-item-line').css('width', this._yearLineItemLineWidth); 
                    } else {
                        // for all items, we let the line expand
                        if($(el).hasClass('timeline__year-line-item--no-century') && $(el).hasClass('timeline__year-line-item--no-decade')) {
                            const width = this._yearLineItemLineWidth + this._decadeWidth + this._centuryWidth + this._lineOffset;

                            $(el).find('.timeline__year-line-item-line').css('width', width); 
                        } else if($(el).hasClass('timeline__year-line-item--no-century')) {
                            const width = this._yearLineItemLineWidth + this._decadeWidth;
                            $(el).find('.timeline__year-line-item-line').css('width', width); 
                        }
                    }
                });
            } else {
                this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
                    if(i > this._activeIndex) {
                        // for all next items, we set the default decade position
                        $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(0)`);

                        // for all next items, we set the default century position
                        $(el).find('.timeline__year-line-item-century').css('transform', `translateX(0)`);
                        
                        // for all next items, we let the decade fade in
                        $(el).find('.timeline__year-line-item-decade').css('opacity', 1);

                        // for all next items, we let the line fade in
                        $(el).find('.timeline__year-line-item-line').css('opacity', 1);

                        // for all next items, handle line width
                        if($(el).hasClass('timeline__year-line-item--no-decade') && $(el).hasClass('timeline__year-line-item--no-century')) {
                            const width = this._yearLineItemLineWidth + this._decadeWidth + this._centuryWidth + this._lineOffset * 2;
                            $(el).find('.timeline__year-line-item-line').css('width', width);
                        } else if($(el).hasClass('timeline__year-line-item--no-century')) {
                            const width = this._yearLineItemLineWidth + this._centuryWidth;
                            $(el).find('.timeline__year-line-item-line').css('width', width);
                        } else {
                            const width = this._yearLineItemLineWidth;
                            $(el).find('.timeline__year-line-item-line').css('width', width);
                        }
                    } else if(i === this._activeIndex) {
                        // for the active element, if id has a decade, we need to apply additional translation
                        // for the active element, we need to adjust the line so it fits
                        if(!$(el).hasClass('timeline__year-line-item--no-decade')) {
                            // if the yearline item which gets active doesnt have a century, but a decade, we need additional translate for its decade
                            let additionalTranslate = this._$rootElement.find('.timeline__fixed-year-century').width();
                            
                            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {

                            } else {
                                additionalTranslate += this._elements.$intro.width() - itemWidth;
                            }
                            
                            $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate}px)`);
                        }

                        $(el).find('.timeline__year-line-item-line').css('opacity', 1);
                        // $(el).find('.timeline__year-line-item-line').css('width', this._yearLineItemLineWidth );
                        $(el).find('.timeline__year-line-item-line').css('width', this._yearLineItemLineWidth - this._lineOffset);
                    }

                    // since we were going from high to low (isLeft), previous items shouldnt need to get touched     
                });
            }
        }

        // special reoutine to handle same index from drag event 
        if(this._activeIndex === this._previousGoTo) {
            this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
                if(i === this._activeIndex) {
                    //start proof: if we clicked twice, proof if century changed and change opacity for  line-item-decade (CL)
                    if(this._lastCentury === this._currentCentury ) {
                        $(el).find('.timeline__year-line-item-decade').css('opacity', 0);
                        $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(0px)`);

                    } else {
                        $(el).find('.timeline__year-line-item-decade').css('opacity', 1);
                    }
                    //end proof

                    // $(el).find('.timeline__year-line-item-decade').css('opacity', 1);

                    $(el).find('.timeline__year-line-item-line').css('opacity', 1);

                    const width = this._yearLineItemLineWidth;

                    $(el).find('.timeline__year-line-item-line').css('width', width); 
                    $(el).find('.timeline__year-line-item-line').css('right', 0); 
                } 
            });
        }

        // perform translations
        if(this._activeIndex === 0) {
            draggable.css('transform', `translateX(0px)`);
            yearlineRoot.css('transform', `translateX(0px)`);
            this._elements.$intro.css('opacity', 1);
            this._translate = 0;
        } else {
            this._elements.$intro.css('opacity', 0);
            const marginFactor = this._itemMarginRight;
            const totalMargin = marginFactor * this._activeIndex;
            const totalItems = itemWidth * this._activeIndex;
            let total = totalItems + totalMargin;
            
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {

            } else {
                total += this._elements.$intro.width() - itemWidth;

            }

            this._translate = total;
            draggable.css('transform', `translateX(${-total}px)`);
            yearlineRoot.css('transform', `translateX(${-total}px)`);
        }



        // if(this._activeIndex === 0) {
        //     draggable.css('transform', `translateX(0px)`);
        //     yearlineRoot.css('transform', `translateX(0px)`);
        //     this._elements.$intro.css('opacity', 1);
        //     this._translate = 0;
        // } else {
        //     this._elements.$intro.css('opacity', 0);
        //     const marginFactor = this._itemMarginRight;
        //     const totalMargin = marginFactor * this._activeIndex;
        //     const totalItems = itemWidth * this._activeIndex;
        //     const total = totalItems + totalMargin + this._elements.$intro.width() - itemWidth;
        //     this._translate = total;
            
        //     this._$rootElement.find('.timeline__year-line-item-line').css('right', 0);

        //     this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
        //         if (i === this._activeIndex) return;
        //         const $el = $(el);
        //         const centuryWidth = $el.find('.timeline__year-line-item-century').width() || 0;
        //         const decadeWidth = $el.find('.timeline__year-line-item-decade').width() || 0;
        //         const combinedWidth = centuryWidth + decadeWidth;
        //         const left = combinedWidth  === 0 ? combinedWidth : combinedWidth + 10;
        //         this._yearLineItemLineLeft = left;
        //         console.log('left', left);
        //         // $el.find('.timeline__year-line-item-line').css('left', left);
        //     });

        //     draggable.css('transform', `translateX(${-total}px)`);
        //     yearlineRoot.css('transform', `translateX(${-total}px)`);

            
        //     prevItem.find('.timeline__year-line-item-decade').css('opacity', `0`);

        //     if(currentItem.hasClass('timeline__year-line-item--no-century') && currentItem.hasClass('timeline__year-line-item--no-decade')) {
        //         this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
        //         this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 1);
        //     } else if (currentItem.hasClass('timeline__year-line-item--no-century') && !currentItem.hasClass('timeline__year-line-item--no-decade')) {
        //         this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
        //         this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 1);
        //     } else if (!currentItem.hasClass('timeline__year-line-item--no-century') && !currentItem.hasClass('timeline__year-line-item--no-decade')) {
        //         this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
        //         this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 0);
        //     }

        //     if(currentItem.hasClass('timeline__year-line-item--no-century')) {
        //         if(!currentItem.hasClass('timeline__year-line-item--no-decade')) {
        //             // if the yearline item which gets active doesnt have a century, but a decade, we need additional translate for its decade
        //             const additionalTranslate = this._$rootElement.find('.timeline__fixed-year-century').width() + this._elements.$intro.width() - itemWidth;
        //             currentItem.find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate}px)`);
        //             // prevItem.addClass('timeline__year-line-item--hide-line');
        //             // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
        //         } else {
        //             // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
        //         }
        //     } else {
        //         if(!currentItem.hasClass('timeline__year-line-item--no-decade')) {
        //             // if the yearline item which gets active has a century, we need to hide the fixed century
        //             this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 0);
        //             // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
        //             const additionalTranslate = this._elements.$intro.width() - itemWidth;    
        //             currentItem.find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate}px)`);
        //             currentItem.find('.timeline__year-line-item-century').css('transform', `translateX(${additionalTranslate}px)`);
        //         } else {
        //             // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
        //         }
        //     }
        // }

        // // remove additional translation from all other inactive items
        // this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
        //     if(i===this._activeIndex) {
        //         $(el).addClass('timeline__year-line-item--active');
        //         $(el).removeClass('timeline__year-line-item--hide-line');

        //     } else {
        //         $(el).removeClass('timeline__year-line-item--active');

        //         if(i >= this._activeIndex) {
        //             $(el).removeClass('timeline__year-line-item--hide-line');
        //             $(el).find('.timeline__year-line-item-decade').css('opacity', `1`);
        //         }

        //         if(i > this._activeIndex) {
        //             $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(0)`);
        //             $(el).find('.timeline__year-line-item-century').css('transform', `translateX(0)`);
        //         }

        //         if(i < this._activeIndex) {
        //             $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(0)`);
        //         }
        //     }
        // });
        this._updateFixedYearHtml();

        setTimeout(() => {
            this._deactivateTransitions();

            if(registerTouchEnd) {
                // this._$rootElement.find('.timeline__draggable').one("touchend", () => this._onTouchEnd());
            }
            

            // since the screen isnt in any interaction now, we can show the fixed year indicators
            this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 1);
            this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
            this._$rootElement.find('.timeline__year-line-item-line').css('opacity', 1);

            if(currentItem.data('index') === this._elements.$item.length - 1) {
                currentItem.find('.timeline__year-line-item-decade').css('opacity', 0);
            }
        }, this._animationLength);

        this._previousGoTo = this._activeIndex;
    }

    _activateTransitions() {
        const draggable = this._$rootElement.find('.timeline__draggable');
        const yearlineRoot = this._$rootElement.find('.timeline__year-line-root');

        this._$rootElement.find('.timeline__year-line-item-decade').css('transition', `transform ${this._animationLength / 1000}s ease-in-out, opacity ${this._animationLength / 1000}s ease-in-out`);
        this._$rootElement.find('.timeline__year-line-item-century').css('transition', `transform ${this._animationLength / 1000}s ease-in-out, opacity ${this._animationLength / 1000}s ease-in-out`);
        draggable.css('transition', `transform ${this._animationLength / 1000}s ease-in-out`);
        yearlineRoot.css('transition', `transform ${this._animationLength / 1000}s ease-in-out`);
        this._elements.$intro.css('transition', `opacity ${this._animationLength / 1000}s ease-in-out`);
        this._$rootElement.find('.timeline__year-line-item-line').css('transition', `width ${this._animationLength / 1000}s ease-in-out, right ${this._animationLength / 1000}s ease-in-out`);
    }

    _deactivateTransitions() {
        const draggable = this._$rootElement.find('.timeline__draggable');
        const yearlineRoot = this._$rootElement.find('.timeline__year-line-root');

        yearlineRoot.css('transition', `none`);
        draggable.css('transition', `none`);
        this._$rootElement.find('.timeline__year-line-item-line').css('transition', 'none');
        this._$rootElement.find('.timeline__year-line-item-decade').css('transition', 'none');
        this._$rootElement.find('.timeline__year-line-item-century').css('transition', 'none');
        this._elements.$intro.css('transition', 'none');
        this._$rootElement.find('.timeline__fixed-year-century').css('transition', 'none');
        this._$rootElement.find('.timeline__fixed-year-decade').css('transition', 'none');
    }

    _updateFixedYearHtml() {
        this._$rootElement.find('.timeline__fixed-year-century').html(this._currentCentury);
        this._$rootElement.find('.timeline__fixed-year-decade').html(this._currentDecade);
    }

    // fired when clicked on navi items and on mouseup after dragging
    _goTo(registerTouchEnd = false) {
        const isLeft = this._activeIndex > this._previousGoTo;

        this._updateDragbar();

        const itemWidth = this._itemWidth;
        const draggable = this._$rootElement.find('.timeline__draggable');
        const yearlineRoot = this._$rootElement.find('.timeline__year-line-root');
        const currentItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex}"]`);
        const prevItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex - 1}"]`);
        const nextItem = this._$rootElement.find(`.timeline__year-line-item[data-index="${this._activeIndex + 1}"]`);

        const currentDecade = currentItem.find('.timeline__year-line-item-decade');
        // currentItem.find('.timeline__year-line-item-line').css('left', this._centuryWidth + currentDecade.width());

        // activate transitions
        this._$rootElement.find('.timeline__year-line-item-decade').css('transition', `transform 1s ease-in-out, opacity 0.4s ease`);
        this._$rootElement.find('.timeline__year-line-item-century').css('transition', `transform 1s ease-in-out, opacity 0.4s ease`);
        draggable.css('transition', `transform 1s ease-in-out`);
        yearlineRoot.css('transition', `transform 1s ease-in-out`);
        this._elements.$intro.css('transition', 'opacity 0.65s ease');
        this._$rootElement.find('.timeline__year-line-item-line').css('transition', 'left 0.65s ease, right 0.65s ease');

        const lastCentury = this._currentCentury;
        const lastDecade = this._currentDecade;

        this._currentCentury = currentItem.data('century');
        this._currentDecade = currentItem.data('decade');

        if(this._activeIndex === 0) {
            draggable.css('transform', `translateX(0px)`);
            yearlineRoot.css('transform', `translateX(0px)`);
            this._elements.$intro.css('opacity', 1);
            this._translate = 0;
        } else {
            this._elements.$intro.css('opacity', 0);
            const marginFactor = this._itemMarginRight;
            const totalMargin = marginFactor * this._activeIndex;
            const totalItems = itemWidth * this._activeIndex;
            const total = totalItems + totalMargin + this._elements.$intro.width() - itemWidth;
            this._translate = total;
            
            this._$rootElement.find('.timeline__year-line-item-line').css('right', 0);

            this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
                if (i === this._activeIndex) return;
                const $el = $(el);
                const centuryWidth = $el.find('.timeline__year-line-item-century').width() || 0;
                const decadeWidth = $el.find('.timeline__year-line-item-decade').width() || 0;
                const combinedWidth = centuryWidth + decadeWidth;
                const left = combinedWidth  === 0 ? combinedWidth : combinedWidth + 10;
                this._yearLineItemLineLeft = left;
                // $el.find('.timeline__year-line-item-line').css('left', left);
            });

            draggable.css('transform', `translateX(${-total}px)`);
            yearlineRoot.css('transform', `translateX(${-total}px)`);

            
            prevItem.find('.timeline__year-line-item-decade').css('opacity', `0`);

            if(currentItem.hasClass('timeline__year-line-item--no-century') && currentItem.hasClass('timeline__year-line-item--no-decade')) {
                this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
                this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 1);
            } else if (currentItem.hasClass('timeline__year-line-item--no-century') && !currentItem.hasClass('timeline__year-line-item--no-decade')) {
                this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
                this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 1);
            } else if (!currentItem.hasClass('timeline__year-line-item--no-century') && !currentItem.hasClass('timeline__year-line-item--no-decade')) {
                this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
                this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 0);
            }

            if(currentItem.hasClass('timeline__year-line-item--no-century')) {
                if(!currentItem.hasClass('timeline__year-line-item--no-decade')) {
                    // if the yearline item which gets active doesnt have a century, but a decade, we need additional translate for its decade
                    const additionalTranslate = this._$rootElement.find('.timeline__fixed-year-century').width() + this._elements.$intro.width() - itemWidth;
                    currentItem.find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate}px)`);
                    // prevItem.addClass('timeline__year-line-item--hide-line');
                    // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
                } else {
                    // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
                }
            } else {
                if(!currentItem.hasClass('timeline__year-line-item--no-decade')) {
                    // if the yearline item which gets active has a century, we need to hide the fixed century
                    this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 0);
                    // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 0);
                    const additionalTranslate = this._elements.$intro.width() - itemWidth;    
                    currentItem.find('.timeline__year-line-item-decade').css('transform', `translateX(${additionalTranslate}px)`);
                    currentItem.find('.timeline__year-line-item-century').css('transform', `translateX(${additionalTranslate}px)`);
                } else {
                    // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
                }
            }
        }

        // remove additional translation from all other inactive items
        this._$rootElement.find('.timeline__year-line-item').each((i, el) => {
            if(i===this._activeIndex) {
                $(el).addClass('timeline__year-line-item--active');
                $(el).removeClass('timeline__year-line-item--hide-line');

            } else {
                $(el).removeClass('timeline__year-line-item--active');

                if(i >= this._activeIndex) {
                    $(el).removeClass('timeline__year-line-item--hide-line');
                    $(el).find('.timeline__year-line-item-decade').css('opacity', `1`);
                }

                if(i > this._activeIndex) {
                    $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(0)`);
                    $(el).find('.timeline__year-line-item-century').css('transform', `translateX(0)`);
                }

                if(i < this._activeIndex) {
                    $(el).find('.timeline__year-line-item-decade').css('transform', `translateX(0)`);
                }
            }
        });

        setTimeout(() => {
            yearlineRoot.css('transition', `none`);
            draggable.css('transition', `none`);
            this._$rootElement.find('.timeline__fixed-year-century').html(this._currentCentury);
            this._$rootElement.find('.timeline__fixed-year-decade').html(this._currentDecade);
            this._$rootElement.find('.timeline__fixed-year-century').css('opacity', 1);
            // this._$rootElement.find('.timeline__fixed-year-decade').css('opacity', 1);
            this._$rootElement.find('.timeline__year-line-item-decade').css('opacity', 1);
            this._$rootElement.find('.timeline__year-line-item-line').css('transition', 'none');
            this._elements.$intro.css('transition', 'none');
            this._$rootElement.find('.timeline__fixed-year-century').css('transition', 'none');
            this._$rootElement.find('.timeline__fixed-year-decade').css('transition', 'none');

            if(registerTouchEnd) {
                // this._$rootElement.find('.timeline__draggable').one("touchend", () => this._onTouchEnd());
            }
            
        }, 1000);
    }

    _updateYearControl(index) {
        const $items = this._$rootElement.find(config.selectors.yearControlItem);
        $items.removeClass(config.classNames.yearControlItemActive);
        $items.removeClass(config.classNames.yearControlItemPreActive);
        this._elements.$yearControlBtn.css('left', `${index * 75}px`);

        $items.each((i, item) => {
            if (i === this._activeIndex) {
                $(item).addClass(config.classNames.yearControlItemActive);
            } else if (i <= this._activeIndex) {
                $(item).addClass(config.classNames.yearControlItemPreActive);
            }
            i++;
        });
    }

    _extractYearsAndDecades() {
        this._elements.$item.each((index, item) => {
            const $item = $(item);
            const year = $item.data(config.dataAttributes.year);
            const decade = this._getDecadeFromYear(year);
            const century = this._getCenturyFromYear(year);

            if (!this._years.includes(year)) this._years.push(year);
            if (!this._decades.includes(decade)) this._decades.push(decade);
            if (!this._centurys.includes(century)) this._centurys.push(century);
        });
    }

    _generateYearIndicators() {
        this._$rootElement.find(config.selectors.item).each((i, el) => {
            const $el = $(el);

            const $yearIndicator = $el.find(config.selectors.itemYearIndicator);
            const year = $el.data(config.dataAttributes.year);

            $yearIndicator.html(this._generateYearIndicatorForItem(year));
        });
    }

    _generateYearlineItem(year, isLast) {
        if (isNaN(year) || isLast) {
            return `
                <div class="timeline__yearline-item">
                    <span class="timeline__yearline-decade"><span class="timeline__yearline-decade-inner">${year}</span></span>
                    <span class="timeline__yearline-line"></span>
                </div>
            `;
        }
        const firstPart = this._getCenturyFromYear(year);
        const secondPart = this._getDecadeFromYear(year);

        const centuryChange = this._lastCentury !== 0 && firstPart !== this._lastCentury;
        const decadeChange = this._lastDecade === 0 || secondPart !== this._lastDecade;

        this._lastDecade = secondPart;
        this._lastCentury = firstPart;

        return `
            <div class="timeline__yearline-item${decadeChange ? ' timeline__yearline-item--decade-change' : ''}">
                ${centuryChange ? `<span class="timeline__yearline-century"><span class="timeline__yearline-century-inner">${firstPart}</span></span>` : ''}
                ${decadeChange ? `<span class="timeline__yearline-decade"><span class="timeline__yearline-decade-inner">${secondPart}</span></span>` : ''}
                <span class="timeline__yearline-line"></span>
            </div>
        `;
    }

    _getCenturyFromYear(year) {
        return year.toString().substring(0, 2);
    }

    _getDecadeFromYear(year, isLastElement = false) {
        if(isNaN(year)) {
            return year.toString().substring(2);
        }

        if(isLastElement) {
            return year.toString().substring(2)  + this._yearEndMarker;
        }

        return year.toString().substring(2,3) + '0' + this._yearEndMarker;
    }

    _generateYearline() {
        let lastCentury = 0;
        let lastDecade = 0;
        const size = this._elements.$item.length;
        
        this._elements.$item.each((i, el) => {
            const $el = $(el);
            const year = $el.data(config.dataAttributes.year);
            const century = this._getCenturyFromYear(year);
            let decade = this._getDecadeFromYear(year);

            if(i === this._elements.$item.length-1) {
                decade = this._getDecadeFromYear(year, true)
            }

            let html = '';

    
                html = `
                    <div class="timeline__year-line-item${century === lastCentury ? ' timeline__year-line-item--no-century' : ''}${decade === lastDecade ? ' timeline__year-line-item--no-decade' : ''}" data-index="${i}" data-century="${century}" data-decade="${decade}" style="left:${(this._itemWidth + this._itemMarginRight) * i}px; width:${this._itemWidth + this._itemMarginRight}px"">
                `;
    
                    // generate a century at item position
                    html += `
                        <span class="timeline__year-line-item-century" style="overflow:hidden; width: ${century !== lastCentury ? 'auto' : 0}">
                            ${century}
                        </span>
                    `;
                
    
                if(decade !== lastDecade) {
                    // generate a decade at item position
                    html += `
                        <span class="timeline__year-line-item-decade" style="opacity: ${decade !== lastDecade ? 1 : 0}">
                            ${decade}
                        </span>
                    `;
                }
    
                html += `
                        <span class="timeline__year-line-item-line">
                            
                        </span>
                `;
    
                html += '</div>';

            

            this._$rootElement.find('.timeline__year-line-root').append(html);

            lastCentury = century;
            lastDecade = decade;
            // $el.append(this._generateYearlineItem(year));
        });

        // this._elements.$yearline.html(html);
    }

    _initBar() {
        // create bar and append into dom
        const barHtml = DragBar.createLabeledHtml(this._years);
        this._elements.$yearControl.html(barHtml);

        // select bar and register callback
        const $bar = this._elements.$yearControl.find(DragBar.getClassname());

        DragBar.init($bar, (index) => {
            this._activeIndex = index;            

            this._goToFromClick();
         
        });

        this._setControlBtnWidth();
    }

    _setControlBtnWidth() {
        const $bar = this._elements.$yearControl.find(DragBar.getClassname());
        const controlBar = $bar.find(config.selectors.controlBtn);
        controlBar.width($bar.width() / this._elements.$item.length);
    }

    _setItemsHeight() {
        if (Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm') || Breakpoints.isBreakpoint('md') ) {
            setTimeout(() => {
                this._elements.$timelineInner.height('auto');
            }, 500);
        } else {
          
            setTimeout(() => {
                const sliderHeight = 750;
                this._elements.$timelineInner.height(`${sliderHeight}px`);
            }, 500);
        }
    }

    _isTouchDevice() {
        return (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0));
      }
}

moduleRegistry.registerModule('Timeline', Timeline);
moduleRegistry.autoApplyModule('Timeline', config.selectors.root);
